import React from 'react';
import { Button, Intent } from '@blueprintjs/core';
import PropTypes from 'prop-types';

const SearchFiltersSearchButton = ({
  onClick,
  loading,
  disabled,
  text = 'Search',
  ...rest
}) => (
  <Button
    intent={Intent.PRIMARY}
    className="filter-bar__search-btn"
    icon="search"
    text={text}
    onClick={onClick}
    loading={loading}
    disabled={disabled}
    {...rest}
  />
);

SearchFiltersSearchButton.propTypes = {
  onClick: PropTypes.func,
  loading: PropTypes.bool,
  disabled: PropTypes.bool,
  text: PropTypes.string,
};

export default SearchFiltersSearchButton;
